import { createFileRoute, Outlet, useNavigate } from '@tanstack/react-router';
import { useUserAccessControl } from '@/context/UserAccessControl';
import { Rol } from '@/constants/roles';
import { ModalError } from '@/components/modal-error/ErrorMessage';
import { Loading } from '@/components/loading';
import { CommonRoute } from '@/constants/routes';

export const Route = createFileRoute('/gestor-requisitos')({
  component: GestorRequirementLayout,
});

function GestorRequirementLayout() {
  const { roleList } = useUserAccessControl();

  const navigate = useNavigate();

  const closeModalError = () => {
    navigate({ to: CommonRoute.LOGIN });
  }

  if (!roleList || roleList.length === 0) return <Loading message='Cargando...' />;
  if (!roleList.some(item => item.id === Rol.EJECUTIVO_DESGRAVAMEN)) {
    return (
      <ModalError
        message="No tienes permisos para acceder a esta página."
        onClose={closeModalError}
      />
    );
  }

  return <Outlet />;
}
